// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3SiKy","icon":"SortAdornment_icon__2uMZt","up":"SortAdornment_up__2Crpw","down":"SortAdornment_down__2XoBW","active":"SortAdornment_active__QoyWU"};